import React from 'react';
import LaunchMonitorFields from '../LaunchMonitorFields';
import { TabProps } from './types';
import { getPriorityClasses } from './helpers';

const Tab2BallFlightData: React.FC<TabProps> = ({
  formData,
  updateFormData,
  updateNestedField,
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">Section 3: Ball Flight Data</h3>

      {/* Launch Monitor Data Only - Manual Entry removed to prevent data collision */}
      <div className="space-y-6">
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
          <p className="text-sm text-blue-700">
            <strong>Launch Monitor Data</strong> - Most accurate for ball flight analysis
          </p>
        </div>

        {/* Data Source Quality Indicators */}
        <div className="bg-gray-50 border border-gray-300 rounded-lg p-4">
          <h4 className="font-medium text-gray-900 mb-3">Data Source Quality</h4>
          <p className="text-sm text-gray-600 mb-4">
            Indicate whether you have actual launch monitor measurements or are estimating values.
            This helps improve recommendation accuracy.
          </p>
          <div className="space-y-3">
            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.has_launch_monitor_driver || false}
                onChange={(e) => updateFormData({ has_launch_monitor_driver: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">
                {formData.has_launch_monitor_driver
                  ? "✅ Using actual launch monitor data for Driver"
                  : "⚠️ Estimating driver data (check if you have actual measurements)"}
              </span>
            </label>
            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.has_launch_monitor_iron || false}
                onChange={(e) => updateFormData({ has_launch_monitor_iron: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">
                {formData.has_launch_monitor_iron
                  ? "✅ Using actual launch monitor data for 7-Iron"
                  : "⚠️ Estimating iron data (check if you have actual measurements)"}
              </span>
            </label>
            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.has_launch_monitor_wedge || false}
                onChange={(e) => updateFormData({ has_launch_monitor_wedge: e.target.checked })}
                className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">
                {formData.has_launch_monitor_wedge
                  ? "✅ Using actual launch monitor data for Wedge"
                  : "⚠️ Estimating wedge data (check if you have actual measurements)"}
              </span>
            </label>
          </div>
        </div>

        <LaunchMonitorFields
          clubType="driver"
          formData={formData}
          updateNestedField={updateNestedField}
          getPriorityClasses={getPriorityClasses}
        />

        <LaunchMonitorFields
          clubType="iron"
          formData={formData}
          updateNestedField={updateNestedField}
          getPriorityClasses={getPriorityClasses}
        />

        <LaunchMonitorFields
          clubType="wedge"
          formData={formData}
          updateNestedField={updateNestedField}
          getPriorityClasses={getPriorityClasses}
        />
      </div>
    </div>
  );
};

export default Tab2BallFlightData;
